import React, { useEffect, useState } from 'react';
import { CSSObject } from '@emotion/react';

import { FormComponent } from 'components';
import { mobile } from 'styles/media';
import {
  ATTENDANCE_OPTIONS,
  SELECTION_OPTIONS,
  toStatusParam,
} from 'data/enroll';
import { AttendanceStatusType, SelectionStatusType } from 'types';

const row: CSSObject = {
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  gap: 8,
  [mobile]: {
    '> label': { width: '100%' },
  },
};

interface Props {
  nameKeyword: string;
  showAttendance: boolean;
  showSelection: boolean;
  onSearchName: (name: string) => void;
  onChangeAttendance: (param?: string) => void;
  onChangeSelection: (param?: string) => void;
}

function VolunteerFilter({
  nameKeyword,
  showAttendance,
  showSelection,
  onSearchName,
  onChangeAttendance,
  onChangeSelection,
}: Props) {
  const [attendance, setAttendance] = useState<AttendanceStatusType[]>(
    ATTENDANCE_OPTIONS.map((o) => o.value),
  );
  const [selection, setSelection] = useState<SelectionStatusType[]>(
    SELECTION_OPTIONS.map((o) => o.value),
  );

  // 필터를 감출 상태(예: 모집중)에서는 걸려 있던 조건도 함께 풀어준다.
  useEffect(() => {
    onChangeAttendance(
      showAttendance
        ? toStatusParam(attendance, ATTENDANCE_OPTIONS.length)
        : undefined,
    );
  }, [attendance, showAttendance]);

  useEffect(() => {
    onChangeSelection(
      showSelection
        ? toStatusParam(selection, SELECTION_OPTIONS.length)
        : undefined,
    );
  }, [selection, showSelection]);

  return (
    <FormComponent.Form
      css={row}
      submit={({ name }: { name?: string }) => onSearchName(name?.trim() ?? '')}
    >
      <FormComponent.SearchInput
        name="name"
        defaultValue={nameKeyword}
        placeholder="참여자 이름으로 검색해주세요"
      />
      {showAttendance && (
        <FormComponent.MultiSelect
          title="출결 상태"
          options={ATTENDANCE_OPTIONS}
          value={attendance}
          handleChange={setAttendance}
        />
      )}
      {showSelection && (
        <FormComponent.MultiSelect
          title="선정 상태"
          options={SELECTION_OPTIONS}
          value={selection}
          handleChange={setSelection}
        />
      )}
    </FormComponent.Form>
  );
}

export default VolunteerFilter;
